import Cookies from 'js-cookie';
import noUiSlider from 'nouislider';

const cookie_lat_name = 'STYXKEY_win_client_lat';
const cookie_long_name = 'STYXKEY_win_client_long';
var currentRequest = null;
var $searchfield = $('.autocomplete');
var matchFlag = 0;
var priceFiltered = 0;
var locationEnabled = 0;
var priceChange = 0;

function dynamic_height_remove($input) {
    if ($input.hasClass('home-autocomplete')) {
        $('.dynamic-height-section').css('height', 'auto');
    }
}
function dynamic_height($results, $no_results, $input) {
    if ($input.hasClass('home-autocomplete')) {
        var autoHeightResults = $results.height();
        var autoHeightnoResults = $no_results.height();
        var bannerHeight = $('.dynamic-height-section').height() - 30;
        var newHeight =
            (autoHeightResults ? autoHeightResults : autoHeightnoResults) +
            bannerHeight;
        $('.dynamic-height-section').height(newHeight);
    }
}

const AutoCompleteV2 = {
    base_url: $('#base-url').attr('data-url'),
    clientLat: '',
    clientLong: '',
    handleResults(results, $input) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');

        $no_results.removeClass('is-active');

        $results.empty();

        var is_small = $results.width() < 480 ? 'is-small' : '';
        var is_medium = $results.width() < 768 ? 'is-medium' : '';
        var exact_match = [];
        matchFlag = 0;
        var fetchArray = [
            'metro_areas',
            'locations',
            'neighborhoods',
            'windsor_properties',
        ];
        if (results['exact_match'] && results['exact_match'].length > 0) {
            exact_match = results['exact_match'][0];
            if (exact_match['post_type'] == 'locations') {
                fetchArray = ['locations', 'metro_areas', 'neighborhoods'];
            } else if (exact_match['post_type'] == 'windsor_properties') {
                fetchArray = ['windsor_properties', 'locations'];
            } else if (exact_match['post_type'] == 'metro_areas') {
                fetchArray = ['metro_areas', 'locations', 'neighborhoods'];
            } else if (exact_match['post_type'] == 'neighborhoods') {
                fetchArray = ['neighborhoods', 'metro_areas', 'locations'];
            }
            matchFlag = 1;
            $('.search-link').val(exact_match.link);
        }
        var match = '';

        fetchArray.forEach((element) => {
            var head = `<li class="group autocomplete-results__item ${is_small} head-text mt-2 pt-6 pl-2">
                        <span class="flex flex-col items-start md:flex md:flex-row md:items-center md:gap-8">
                            <span class="text-brand-primary group-hover:text-brand-primary ">`;
            if (element == 'windsor_properties') {
                head += `COMMUNITIES`;
            } else if (element == 'locations') {
                head += `CITIES`;
            } else if (element == 'metro_areas') {
                head += `METRO AREAS`;
            } else if (element == 'neighborhoods') {
                head += `NEIGHBORHOODS`;
            }
            head += `</span>
                        </span>
                </li>`;
            if (
                (results[element] && results[element].length > 0) ||
                (exact_match &&
                    exact_match.hasOwnProperty('post_type') &&
                    exact_match['post_type'] == element)
            ) {
                $results.append(head);
            }

            if (
                exact_match &&
                exact_match.hasOwnProperty('post_type') &&
                exact_match['post_type'] == element
            ) {
                match += `<li class="group autocomplete-results__item ${is_small}" data-link="${exact_match.link}" data-name="${exact_match.title}">
                    <a href="${exact_match.link}" class="autocomplete-results__link match-value">
                        <span class="flex flex-col items-start md:flex md:flex-row md:items-center md:gap-8">`;
                if (element == 'metro_areas' || element == 'neighborhoods') {
                    if (
                        exact_match.title == 'Washington D.C.' ||
                        exact_match.title == 'Washington DC' ||
                        exact_match.title == 'New York' ||
                        exact_match.title == 'DC'
                    ) {
                        match += `<span class="result-part1 text-secondary-blue md:text-lg">
                                ${exact_match.title}
                            </span>
                            <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                    } else {
                        match += `<span class="result-part1 text-secondary-blue md:text-lg">
                                ${exact_match.title}, ${exact_match.abbreviation}
                            </span>
                            <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                    }
                } else {
                    match += `<span class="result-part1 text-secondary-blue md:text-lg">
                                ${exact_match.title}
                            </span>
                            <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                }
                if (
                    element == 'locations' ||
                    element == 'metro_areas' ||
                    element == 'neighborhoods'
                ) {
                    match += `${
                        exact_match.num_properties == 1
                            ? `${exact_match.num_properties} Community`
                            : `${exact_match.num_properties} Communities`
                    }`;
                } else if (element == 'windsor_properties') {
                    match += `${exact_match.location}`;
                }
                match += `</span>
                        </span>
                    </a>
                </li>`;
                $results.append(match);
            }
            if (results[element] && results[element].length > 0) {
                $.each(results[element], function (i, loc) {
                    var data = `
                        <li class="group autocomplete-results__item ${is_small}" data-link="${loc.link}" data-name="${loc.title}">
                            <a href="${loc.link}" class="autocomplete-results__link">
                                <span class="flex flex-col items-start md:flex md:flex-row md:items-center md:gap-8">`;
                    if (
                        element == 'metro_areas' ||
                        element == 'neighborhoods'
                    ) {
                        if (
                            loc.title == 'Washington D.C.' ||
                            loc.title == 'Washington DC' ||
                            loc.title == 'New York' ||
                            loc.title == 'DC'
                        ) {
                            data += `<span class="result-part1 text-secondary-blue md:text-lg">
                                                        ${loc.title}
                                                    </span>
                                                    <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                        } else {
                            data += `<span class="result-part1 text-secondary-blue md:text-lg">
                                                        ${loc.title}, ${loc.abbreviation}
                                                    </span>
                                                    <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                        }
                    } else {
                        data += `<span class="result-part1 text-secondary-blue md:text-lg">
                                                    ${loc.title}
                                                </span>
                                                <span class="result-part2 md:text-[18px] text-neutral-dark-gray font-normal">`;
                    }
                    if (
                        element == 'locations' ||
                        element == 'metro_areas' ||
                        element == 'neighborhoods'
                    ) {
                        data += `${
                            loc.num_properties == 1
                                ? `${loc.num_properties} Community`
                                : `${loc.num_properties} Communities`
                        }`;
                    } else if (element == 'windsor_properties') {
                        data += `${loc.location}`;
                    }
                    `</span>
                                </span>
                            </a>
                        </li>
                    `;
                    $results.append(data);
                });
            }
        });
        if (matchFlag == 1) {
            $('.cta-search').addClass('enabled');
            $('.icon-search').addClass('enabled');
            $('.icon-search img').attr(
                'src',
                $('.icon-search img').data('enabled-img')
            );
        } else {
            $('.cta-search').removeClass('enabled');
            $('.icon-search').removeClass('enabled');
            $('.icon-search img').attr(
                'src',
                $('.icon-search img').data('disabled-img')
            );
        }
        $results.addClass('is-active');
        $input.closest('.autocomplete').addClass('active');
        dynamic_height($results, $no_results, $input);

        // focus the first result
    },
    handleNoResults($input, suggestions = []) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');

        $results.empty();
        $results.removeClass('is-active');
        if (suggestions && Object.keys(suggestions).length > 0) {
            $no_results.html(
                "<p class='text-lg mb-5 no-results-text pt-4'> We can't find \"" +
                    $input.val() +
                    "\"</p><span class='md:text-base font-playfair'>Did you mean: <span class='no-results-suggestions'>\"<a href='javascript:void(0);' class='suggestion-update underline'>" +
                    suggestions['title'] +
                    '</a>"</span></span>'
            );
        } else {
            $no_results.html(
                "<p class='text-lg mb-5 no-results-text pt-4'>Sorry we haven't settled there yet.</p><a href='/find-apartments/' class='text-base no-results-link py-1'>View All Windsor Locations<span class='ml-2 arw-right inline-block w-[6px] h-[12px]'> </span></a>"
            );
        }
        $no_results.addClass('is-active');
        $input.closest('.autocomplete').addClass('active');
        dynamic_height($results, $no_results, $input);
    },
    clearResults($input) {
        var $results = $input.next('.autocomplete-results');
        var $no_results = $input.next().next('.autocomplete-no-results');

        $results.empty().removeClass('is-active');
        $no_results.removeClass('is-active');
        $input.closest('.autocomplete').removeClass('active');
        dynamic_height_remove($input);
    },
    doSearch($input) {
        $(document).off('keydown', AutoCompleteV2.handleUpDown);

        var searchVal = $input.val();
        if ($input.hasClass('no-communities')) {
            if (
                $.inArray(searchVal.toLowerCase(), [
                    'dc',
                    'd.c',
                    'd.c.',
                    'dc.',
                    'washington dc.',
                    'washington d.c',
                    'washington dc',
                ]) !== -1
            ) {
                searchVal = 'Washington D.C.';
            }
        } else {
            if (
                $.inArray(searchVal.toLowerCase(), [
                    'dc',
                    'd.c',
                    'd.c.',
                    'dc.',
                    'washington dc.',
                    'washington d.c',
                    'washington dc',
                ]) !== -1
            ) {
                searchVal = 'Washington DC';
            }
        }
        if (
            searchVal.length > 2 ||
            (locationEnabled == 1 && searchVal.length == 0)
        ) {
            AutoCompleteV2.clearResults($input);
            AutoCompleteV2.showLoader($input);
            var innerFlag = 0;
            if ($input.hasClass('no-communities')) {
                innerFlag = 1;
            }
            currentRequest = $.ajax({
                url: AutoCompleteV2.base_url + '/wp-admin/admin-ajax.php',
                method: 'POST',
                data: {
                    action: 'autocomplete_location_property_search_v2',
                    s: searchVal,
                    lat: AutoCompleteV2.clientLat,
                    long: AutoCompleteV2.clientLong,
                    innerFlag: innerFlag,
                },
                beforeSend: function () {
                    if (currentRequest != null) {
                        currentRequest.abort();
                    }
                },
                success: function (data) {
                    AutoCompleteV2.hideLoader($input);
                    if (data) {
                        var results = JSON.parse(data);
                        if (
                            results &&
                            ((results.windsor_properties &&
                                results.windsor_properties.length > 0) ||
                                (results.locations &&
                                    results.locations.length > 0) ||
                                (results.exact_match &&
                                    results.exact_match.length > 0) ||
                                (results.metro_areas &&
                                    results.metro_areas.length > 0) ||
                                (results.neighborhoods &&
                                    results.neighborhoods.length > 0))
                        ) {
                            AutoCompleteV2.handleResults(results, $input);
                        } else {
                            $('.cta-search').removeClass('enabled');
                            $('.icon-search').removeClass('enabled');
                            $('.icon-search img').attr(
                                'src',
                                $('.icon-search img').data('disabled-img')
                            );
                            AutoCompleteV2.clearResults($input);
                            if ($input.val().length > 2) {
                                var suggestions = [];
                                if (
                                    results.suggestions &&
                                    Object.keys(results.suggestions).length > 0
                                ) {
                                    suggestions = results.suggestions;
                                }
                                AutoCompleteV2.handleNoResults(
                                    $input,
                                    suggestions
                                );
                            }
                        }
                    }
                },
            });
        } else {
            if (currentRequest != null) {
                currentRequest.abort();
            }
            AutoCompleteV2.clearResults($input);
            AutoCompleteV2.hideLoader($input);
            $('.cta-search').removeClass('enabled');
            $('.icon-search').removeClass('enabled');
            $('.icon-search img').attr(
                'src',
                $('.icon-search img').data('disabled-img')
            );
        }
    },
    handleUpDown(e) {
        var $focused_li = $('.autocomplete-results a:focus').parent();
        // if in input, make the down press select the first option
        switch (e.keyCode) {
            case 38: // up
                if ($focused_li.length > 0 && $focused_li.index() > 0) {
                    // if in a result, select the previous result
                    $focused_li.prev().find('a').focus();
                    return false;
                }
                break;
            case 40: // down
                if ($('.autocomplete-input-v2:focus').length > 0) {
                    // if in the autocomplete, select the first result
                    $('.autocomplete-input-v2:focus')
                        .next('.autocomplete-results')
                        .find('li')
                        .eq(0)
                        .find('a')
                        .trigger('focus');
                    return false;
                }

                if ($focused_li.length > 0 && $focused_li.next().length > 0) {
                    // if in a result, select the next result
                    $focused_li.next().find('a').focus();
                    $focused_li.next()[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start',
                    });

                    return false;
                }
                break;
        }
    },
    showLoader($input) {
        $input.parent().find('.autocomplete-loading').addClass('is-loading');
    },
    hideLoader($input) {
        $input.parent().find('.autocomplete-loading').removeClass('is-loading');
    },
    geoLocationPermissionCheck() {
        if (AutoCompleteV2.isIOS16OrLesser()) {
            AutoCompleteV2.geoLocationPermissionCheckForIos();
        } else {
            // Check for Geolocation support
            if ('geolocation' in navigator) {
                navigator.permissions
                    .query({ name: 'geolocation' })
                    .then(function (permissionStatus) {
                        // Check permission status
                        if (permissionStatus.state === 'denied') {
                            Cookies.remove(cookie_lat_name);
                            Cookies.remove(cookie_long_name);
                            // Perform actions when location permission is denied
                        } else if (permissionStatus.state === 'granted') {
                            AutoCompleteV2.getLocation();
                            // Perform actions when location permission is granted
                        } else if (permissionStatus.state === 'prompt') {
                            Cookies.remove(cookie_lat_name);
                            Cookies.remove(cookie_long_name);
                            // Permission is not denied or granted yet, it's in the prompt state
                        }

                        // Listen for changes in permission status
                        permissionStatus.onchange = function () {
                            if (permissionStatus.state === 'denied') {
                                Cookies.remove(cookie_lat_name);
                                Cookies.remove(cookie_long_name);
                                locationEnabled = 0;
                                // Perform actions when location permission is denied after initially being granted
                            } else if (permissionStatus.state === 'granted') {
                                AutoCompleteV2.getLocation();
                                // Perform actions when location permission is granted after initially being denied
                            }
                        };
                    });
            } else {
            }
        }
    },
    isIOS16OrLesser() {
        const iOSMatch = navigator.userAgent.match(
            /(iPad|iPhone|iPod).*OS\s([\d_\.]+)/
        );

        let isIOS =
            iOSMatch ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (isIOS) {
            var agent = window.navigator.userAgent,
                start = agent.indexOf('OS ');
            var iosVersion = 0;
            if (
                (agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) &&
                start > -1
            ) {
                var versionString = agent
                    .substr(start + 3, 3)
                    .replace('_', '.');
                iosVersion = parseFloat(versionString) || 0;
            } else if (agent.indexOf('Version/') > -1) {
                var versionIndex = agent.indexOf('Version/') + 8;
                var versionString = agent.substring(
                    versionIndex,
                    agent.indexOf(' ', versionIndex)
                );
                iosVersion = parseFloat(versionString) || 0;
            }

            if (iosVersion < 16) {
                return true;
            }
        }
        return false;
    },
    geoLocationPermissionCheckForIos() {
        // Check for Geolocation support
        AutoCompleteV2.getLocation();
    },
    findNearByArea(locationType, callback) {
        $.ajax({
            url: AutoCompleteV2.base_url + '/wp-admin/admin-ajax.php',
            method: 'POST',
            data: {
                action: 'autocomplete_location_near_by',
                lat: AutoCompleteV2.clientLat,
                long: AutoCompleteV2.clientLong,
                type: locationType,
            },
            success: function (response) {
                // Call the callback function with the response
                callback(JSON.parse(response));
            },
        });
    },
    handleClick(e) {
        e.preventDefault();
        $('html, body').animate(
            {
                scrollTop: $('.state-listing').offset().top,
            },
            1000
        );
        
        const firstItemLink = $('.state-thumbnail-component .state-thumbnail-item a').first();
        if (firstItemLink.length) {
            firstItemLink.focus();
        }
    },
    init() {
        AutoCompleteV2.geoLocationPermissionCheck();
        setTimeout(() => {
            if (locationEnabled == 1 && $('.metro-dynamic-section').length) {
                // Call findNearByArea with a callback function to handle the response
                AutoCompleteV2.findNearByArea(
                    'metro_areas',
                    function (response) {
                        if (response && Object.keys(response).length > 0) {
                            // Update UI elements based on the response
                            $('.metro-dynamic-section .promo-top-button').css(
                                'display',
                                'inline-block'
                            );
                            $('.metro-dynamic-section h3').text(
                                'Picturing Yourself in ' + response.title + '?'
                            );
                            $('.metro-dynamic-section p').text(
                                'Find your perfect fit among our apartments for rent in ' +
                                    response.title +
                                    '.'
                            );
                            $('.metro-dynamic-section a')
                                .not('.promo-top-button')
                                .text('EXPLORE AREA');
                            $('.metro-dynamic-section a')
                                .not('.promo-top-button')
                                .attr('href', response.link);
                            if (
                                response.metro_image &&
                                response.metro_image.length > 0
                            ) {
                                $('.metro-dynamic-section img').attr(
                                    'src',
                                    response.metro_image
                                );
                                $('.metro-dynamic-section img').attr(
                                    'alt',
                                    response.title + ' Image'
                                );
                            }
                            $(
                                '.search-by-state-find-apartments .container a:not(.promo-top-button)'
                            ).off('click', AutoCompleteV2.handleClick);
                        }
                    }
                );
            }
        }, 1000);

        // Attach click event handler
        $(
            '.search-by-state-find-apartments .container a:not(.promo-top-button)'
        ).on('click', AutoCompleteV2.handleClick);
        $('.autocomplete-input-v2').each(function () {
            var $ac = $(this);
            $(this).on('keyup', function (e) {
                if (e.which != 13) {
                    AutoCompleteV2.doSearch($ac);
                } else {
                    if (matchFlag == 1) {
                        window.location.href = $('.match-value').attr('href');
                    }
                }
            });
        });
        $('.do-search').each(function () {
            var $ac = $(this);
            $(this).on('click', function (e) {
                if ($('.in-page-search .do-search').length) {
                    if ($(this).hasClass('enabled')) {
                        var searchURL = $('.search-link').val();
                        var filterPriceMin =
                            document.getElementById('filter-price-min');
                        var filterPriceMax =
                            document.getElementById('filter-price-max');
                        if (
                            $('#search-token-price').length > 0 &&
                            filterPriceMax &&
                            filterPriceMin &&
                            priceFiltered == 1
                        ) {
                            var price =
                                filterPriceMin.value +
                                ':' +
                                filterPriceMax.value;
                            searchURL = AutoCompleteV2.appendQueryParam(
                                searchURL,
                                'price',
                                price
                            );
                        }
                        var date = $('#date-filter').val();
                        if ($('#search-token-date').length > 0 && date) {
                            var date_array = date.split('/');
                            var date_formatted =
                                date_array[2] +
                                '-' +
                                date_array[0] +
                                '-' +
                                date_array[1];
                            searchURL = AutoCompleteV2.appendQueryParam(
                                searchURL,
                                'date',
                                date_formatted
                            );
                        }
                        var checkedBed = $(
                            '.search-filter .bed-check .is-active'
                        );
                        var num_beds = [];
                        checkedBed.each(function () {
                            num_beds.push($(this).data('value'));
                        });
                        if ($('.bed-tokens').length > 0 && num_beds.length) {
                            searchURL = AutoCompleteV2.appendQueryParam(
                                searchURL,
                                'beds',
                                num_beds.join(',')
                            );
                        }
                        window.location.href = searchURL;
                    }
                } else {
                    if (matchFlag == 1) {
                        window.location.href = $('.match-value').attr('href');
                    }
                }
            });
        });
        AutoCompleteV2.filterPrice();
        AutoCompleteV2.filterDate();
        AutoCompleteV2.filterBeds();
        AutoCompleteV2.resetToken();

        $('.autocomplete-input-v2').on('click', function () {
            AutoCompleteV2.doSearch($(this));
        });

        // remove results on click outside
        $(document).on('click', function (event) {
            var $target = $(event.target);
            if (
                !$target.closest('.autocomplete').length &&
                $('.autocomplete').is(':visible')
            ) {
                AutoCompleteV2.clearResults($('.autocomplete-input-v2'));
                // console.log("Click");
            }
        });

        $('.autocomplete-no-results').on(
            'click',
            '.suggestion-update',
            function (event) {
                var suggestion = $(this).text();
                var autocompleteContainer = $(this).closest('.autocomplete');
                var $input = autocompleteContainer.find(
                    '.autocomplete-input-v2'
                );
                $input.val(suggestion);
                $input.focus();
                $input.trigger('keyup');
            }
        );

        // Function for getting user current location
        $('.get-location').on('click', function () {
            AutoCompleteV2.getLocation();
        });

        $('.autocomplete-results__item').on('click', function () {
            AutoCompleteV2.getLocation();
        });

        $('.dummy-get-location').on('click', function () {
            AutoCompleteV2.clientLat = $('#dummy-lat').val();
            AutoCompleteV2.clientLong = $('#dummy-long').val();
            locationEnabled = 1;
            Cookies.set(cookie_lat_name, AutoCompleteV2.clientLat);
            Cookies.set(cookie_long_name, AutoCompleteV2.clientLong);
        });
        $('.in-page-search').on(
            'click',
            '.autocomplete-results__item',
            function (event) {
                event.preventDefault();
                var suggestion = $(this).data('name');
                var link = $(this).data('link');
                $('.autocomplete-input-v2').val(suggestion);
                $('.search-link').val(link);
                $('.cta-search').addClass('enabled');
                $('.icon-search img').attr(
                    'src',
                    $('.icon-search img').data('enabled-img')
                );
                $('.autocomplete-input-v2').focus();
                var $results = $(this).parent();
                $results.empty();
                $results.removeClass('is-active');
            }
        );

        const $homeSearchbar = $('.home-searchbar-container');
        let homeSearchbarIsFocusInside = false;

        $homeSearchbar.on('focusin', function () {
            homeSearchbarIsFocusInside = true;
            // console.log('Focus inside home searchbar');
        });

        $homeSearchbar.on('focusout', function (event) {
            setTimeout(() => {
                if (!$.contains($homeSearchbar[0], event.relatedTarget) && $('.autocomplete').is(':visible')) {
                    homeSearchbarIsFocusInside = false;
                    console.log('Focus left home searchbar');
                    AutoCompleteV2.clearResults($('.autocomplete-input-v2'));
                }
            }, 250);
        });
        
    },
    appendQueryParam(url, key, value) {
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        return (
            url +
            separator +
            encodeURIComponent(key) +
            '=' +
            encodeURIComponent(value)
        );
    },
    getLocation() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => this.showPosition(position),
                (error) => this.showError(error)
            );
        } else {
        }
    },
    showPosition(position) {
        AutoCompleteV2.clientLat = position.coords.latitude;
        AutoCompleteV2.clientLong = position.coords.longitude;
        locationEnabled = 1;
        Cookies.set(cookie_lat_name, AutoCompleteV2.clientLat);
        Cookies.set(cookie_long_name, AutoCompleteV2.clientLong);
    },
    // Function to set a cookie
    setCookie(name, value) {
        var cookieString = name + '=' + encodeURIComponent(value) + '; path=/';

        // Set the cookie
        document.cookie = cookieString;
    },

    showError(error) {
        switch (error.code) {
            case error.PERMISSION_DENIED:
                break;
            case error.POSITION_UNAVAILABLE:
                break;
            case error.TIMEOUT:
                break;
            case error.UNKNOWN_ERROR:
                break;
            default:
        }
        Cookies.remove(cookie_lat_name);
        Cookies.remove(cookie_long_name);
    },
    filterPrice() {
        if ($('.in-page-search-filter').length) {
            if ($('#price-slider').length < 1) return;
            var filterPriceMin = document.getElementById('filter-price-min');
            var filterPriceMax = document.getElementById('filter-price-max');
            var min = 900;
            var max = 50000;
            var start_min = filterPriceMin.value ? filterPriceMin.value : min;
            var start_max = filterPriceMax.value ? filterPriceMax.value : max;
            var slider = document.getElementById('price-slider');
            noUiSlider.create(slider, {
                start: [start_min, start_max],
                connect: true,
                step: 5,
                range: {
                    min: min,
                    max: max,
                },
                format: {
                    to: function (value) {
                        return Math.round(value);
                    },
                    from: function (value) {
                        return Math.round(value);
                    },
                },
            });

            // handle interaction
            slider.noUiSlider.on('update', function (values, handle) {
                if (priceChange == 1) {
                    if (handle == 0) {
                        filterPriceMin.value = values[handle];
                    }
                    if (handle == 1) {
                        filterPriceMax.value = values[handle];
                    }
                }
            });
            filterPriceMin.addEventListener('change', function () {
                if (this.value != '') {
                    priceChange = 1;
                }
                slider.noUiSlider.set([this.value, null]);
            });
            filterPriceMax.addEventListener('change', function () {
                if (this.value != '') {
                    priceChange = 1;
                }
                slider.noUiSlider.set([null, this.value]);
            });
            var currentMinPrice = filterPriceMin.value;
            var currentMaxPrice = filterPriceMax.value;
            // handle apply
            $('[data-filter=price] .search-filter__apply').on(
                'click',
                function () {
                    $('.search-filter-toggle').removeClass('is-open');
                    $('.search-filter').attr('open', false);
                    currentMinPrice = filterPriceMin.value;
                    currentMaxPrice = filterPriceMax.value;
                    if (currentMinPrice != '' && currentMaxPrice != '') {
                        $('.search-filter-toggle[data-filter=price]').addClass(
                            'is-active'
                        );
                        AutoCompleteV2.generateToken(
                            'price',
                            '$' + currentMinPrice + ' - $' + currentMaxPrice
                        );
                        priceFiltered = 1;
                    }

                    $('.search-filter-toggle[data-filter=price] a').focus();
                    return false;
                }
            );

            // handle reset
            $('[data-filter=price] .search-filter__reset').on(
                'click',
                function () {
                    AutoCompleteV2.resetPrice();
                    $('#search-token-price').remove();
                    return false;
                }
            );
        }
    },
    resetPrice() {
        var filterPriceMin = document.getElementById('filter-price-min');
        var filterPriceMax = document.getElementById('filter-price-max');
        var slider = document.getElementById('price-slider');
        var min = 900;
        var max = 50000;
        priceChange = 0;

        filterPriceMin.value = '';
        filterPriceMax.value = '';
        slider.noUiSlider.set([min, max]);

        $('[data-filter=price]').removeClass('is-active');
    },
    filterDate() {
        if ($('.in-page-search-filter').length) {
            $('[data-filter=date] .search-filter__apply').on(
                'click',
                function () {
                    $('.search-filter-toggle').removeClass('is-open');
                    $('.search-filter').attr('open', false);

                    var date = $('#date-filter').val();

                    console.log('DAte', date);

                    // $('#date-filter').datepicker('setDate', date);
                    $('#slcted-date').val(date);
                    if (date) {
                        $('.search-filter-toggle[data-filter=date]').addClass(
                            'is-active'
                        );
                        AutoCompleteV2.generateToken('date', date);
                    }
                    $('.search-filter-toggle[data-filter=date] a').focus();

                    return false;
                }
            );

            // handle reset
            $('[data-filter=date] .search-filter__reset').on(
                'click',
                function () {
                    AutoCompleteV2.resetDate();
                    $('#search-token-date').remove();
                    $('#slcted-date').val('');
                    return false;
                }
            );

            $('[data-filter=date] .search-filter__close').on(
                'click',
                function () {
                    const slctDate = $('#slcted-date').val();

                    if (slctDate) {
                        $('#date-filter').val(
                            new Date(slctDate).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                            })
                        );
                    }
                }
            );
        }
    },
    resetDate() {
        var date = $('#date-filter').val('');
        $('#slcted-date').val('');
        $('.search-filter-toggle[data-filter=date]').removeClass('is-active');
    },
    filterBeds() {
        if ($('.in-page-search-filter').length) {
            $('[data-filter=beds] .search-filter__apply').on(
                'click',
                function () {
                    $('.search-filter-toggle').removeClass('is-open');
                    $('.search-filter').attr('open', false);
                    var checkedBed = $('.search-filter .bed-check .is-active');
                    var num_beds = [];
                    $('.bed-tokens').remove();
                    checkedBed.each(function () {
                        num_beds.push($(this).data('value'));
                        var value = '';
                        var key = '';
                        if ($(this).data('value') == 'studio') {
                            value = 'Studio';
                            key = 'bed-studio';
                        } else if ($(this).data('value') == '3') {
                            value = '3+ Beds';
                            key = 'bed-3';
                        } else {
                            if ($(this).data('value') == 1) {
                                value = $(this).data('value') + ' Bed';
                            } else {
                                value = $(this).data('value') + ' Beds';
                            }
                            key = 'bed-' + $(this).data('value');
                        }
                        AutoCompleteV2.generateToken(key, value, 'bed-tokens');
                    });
                    if (num_beds.length) {
                        $('.search-filter-toggle[data-filter=beds]').addClass(
                            'is-active'
                        );
                    }
                    console.log($('.search-filter-toggle[data-filter=beds] a'));
                    $('.search-filter-toggle[data-filter=beds] a').focus();

                    return false;
                }
            );

            $('[data-filter=beds] .search-filter__reset').on(
                'click',
                function () {
                    AutoCompleteV2.resetBeds();
                    return false;
                }
            );

            $('[data-filter=beds] .search-filter__close').on(
                'click',
                function () {
                    var checkedBed = [];
                    $('.bed-tokens').each(function () {
                        checkedBed.push($(this).find('span').text());
                    });

                    var newBeds = $('.search-filter .bed-check .is-active');
                    newBeds.each(function () {
                        var bed = $.trim($(this).text());
                        if (!checkedBed.includes(bed)) {
                            $(this).removeClass('is-active');
                        }
                    });

                    return false;
                }
            );
        }
    },
    resetBeds() {
        $('.num-beds .bed-button').removeClass('is-active');
        $('.beds-exact').prop('checked', false);

        $('.bed-check .bg-checkbox-default').removeClass('is-active');
        $('.bed-tokens').remove();
    },
    generateToken(id, data, commonClass = '') {
        if ($('.in-page-search-filter').length) {
            if (id == 'more') {
                var count = SingleLocations.moreFilterCount;
                if (SingleLocations.commutePin) {
                    count = SingleLocations.moreFilterCount + 1;
                }
                data = data + ' (' + count + ')';
            }
            if ($('#search-token-' + id).length) {
                $('#search-token-' + id).remove();
            }
            var copiedToken = $('#search-token-dummy').clone();
            copiedToken.attr('id', 'search-token-' + id);
            if (commonClass.length) {
                copiedToken.addClass(commonClass);
            }
            copiedToken.find('#token-text').text(data);
            copiedToken.find('.token-close-cta').attr('id', 'close-cta-' + id);
            copiedToken.find('.token-close-cta').attr('data-value', id);
            copiedToken.css('display', 'flex');
            $('.tokens-wrapper .token-div').append(copiedToken);
        }
    },
    resetToken() {
        if ($('.in-page-search-filter').length) {
            $('.tokens-wrapper').on('click', function (e) {
                if ($(e.target).hasClass('token-cls-pth')) {
                    $(e.target).parent().trigger('click');
                    return false;
                }
                if ($(e.target).hasClass('token-close-cta')) {
                    $(e.target).find('svg').trigger('click');
                    return false;
                }
                if ($(e.target).parent().hasClass('token-close-cta')) {
                    var tokenToRemove = $(e.target).parent().data('value');
                    if (tokenToRemove == 'date') {
                        AutoCompleteV2.resetDate();
                    }
                    if (tokenToRemove == 'price') {
                        AutoCompleteV2.resetPrice();
                    }
                    if (tokenToRemove.indexOf('bed-') !== -1) {
                        var valueArray = tokenToRemove.split('-');
                        $(
                            '.bed-check [data-value="' + valueArray[1] + '"]'
                        ).removeClass('is-active');
                        var checkedBed = $(
                            '.search-filter .bed-check .is-active'
                        );
                        var num_beds = [];
                        checkedBed.each(function () {
                            num_beds.push($(this).data('value'));
                            var value = '';
                            var key = '';
                            if ($(this).data('value') == 'studio') {
                                value = 'Studio';
                                key = 'bed-studio';
                            } else {
                                value = $(this).data('value') + ' Bed';
                                key = 'bed-' + $(this).data('value');
                            }
                        });
                        if (num_beds.length) {
                            $(
                                '.search-filter-toggle[data-filter=beds]'
                            ).addClass('is-active');
                        } else {
                            $(
                                '.search-filter-toggle[data-filter=beds]'
                            ).removeClass('is-active');
                        }
                    }
                    $('#search-token-' + tokenToRemove).remove();
                    return false;
                }
            });
        }
    },
};

export default AutoCompleteV2;
